import ApiService from "@Src/services/ApiService";

export interface BoardData {
    Id: number;
    Name: string;
    RegistrationDate: string | null;
    boardImageUrl: string | null;
    Description: string;
}

export interface AllBoardListResponse {
    success: boolean;
    StatusMsg: string;
    ResponseType: string;
    data: BoardData[];
}

export async function getAllBoardList(): Promise<AllBoardListResponse> {
    return await ApiService.fetchData({
        url: 'home/FullBoardList',
        method: "get"
    });
}
